import { describeUploadError, validateRegistrationUploadFile } from './registrationUpload';

/** Shared upload guard / failure helpers for CUploadPage, OGUploadPage, FGUploadPage. */
export function applyRegistrationUploadPageMixin(ComponentClass) {
    const proto = ComponentClass.prototype;

    proto.uploadErrorMessage = function uploadErrorMessage(slot) {
        const msg = this.state.uploadErrors && this.state.uploadErrors[slot];
        return msg || 'فایل آپلود نشد';
    };

    proto.failRegistrationUpload = function failRegistrationUpload(slot, message) {
        this.setState((prev) => ({
            [`isLoading${slot}`]: false,
            [`isUpload${slot}`]: true,
            [`hasError${slot}`]: true,
            uploadErrors: {...(prev.uploadErrors || {}), [slot]: message},
        }));
    };

    proto.beginRegistrationUpload = function beginRegistrationUpload(e, slot) {
        const file = e?.target?.files?.[0];
        if (file === undefined) {
            return null;
        }
        const validation = validateRegistrationUploadFile(file);
        if (!validation.ok) {
            this.failRegistrationUpload(slot, validation.message);
            if (e.target) {
                e.target.value = '';
            }
            return null;
        }
        this.setState((prev) => ({
            uploadErrors: {...(prev.uploadErrors || {}), [slot]: ''},
        }));
        return file;
    };

    proto.failRegistrationUploadFromApi = function failRegistrationUploadFromApi(slot, err, file) {
        this.failRegistrationUpload(slot, describeUploadError(err, file));
    };
}

export const REGISTRATION_UPLOAD_SLOTS = [
    'BirthPage1',
    'BirthPage2',
    'BirthPage3',
    'BirthPage4',
    'BirthAllPage',
    'CartPage1',
    'CartPage2',
    'CartAllPage',
    'PersonnelImg',
    'Register',
    'RegisterUni',
    'CommitmentLetter',
];
